import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { getImageAssetPath } from "~/utils/assets";
export class menuNav_template extends vnTemplate {
    getTemplateHtml() {
        return /* html */ `
            <a class="navigation-brand" aria-label="Military LeadPilot" href="/">
                <span class="navigation-brand__icon" aria-hidden="true">
                    <img src="${getImageAssetPath("brand/leadpilot-icon.svg")}" alt="" width="24" height="24">
                </span>
                <span>LeadPilot</span>
            </a>
        `;
    }
    getTemplateName() {
        return "menuNav-template";
    }
    getMainElementType() {
        return "nav";
    }
    getMainElementClasses() {
        return ["main-nav"];
    }
    buildViewModel() {
        return {
            isUserLoggedIn: ko.observable(false),
            navBarItems: ko.observableArray([]),
        };
    }
    setMenus(menus) {
        this.getTemplateViewModel().navBarItems(menus);
    }
    setIsUserLoggedIn(isUserLoggedIn) {
        this.getTemplateViewModel().isUserLoggedIn(isUserLoggedIn);
    }
}
